import React, { useState, useEffect } from "react";
import {
  Button,
  Popover,
  Typography,
  List,
  ListItem,
  Menu,
  MenuItem,
  TextField,
  Avatar,
} from "@mui/material";
import FilterIcon from "@mui/icons-material/FilterList";
import { makeStyles } from "@material-ui/core/styles";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import SaveIcon from "@mui/icons-material/Save";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SelectFilter from "../SelectFilter";
import SavedFilters from "../SavedFilters";
import PL3Filters from "../PL3Filters";
import ProductsFilters from "../ProductsFilters";
import EditSavedFilters from "../EditSavedFilters";
import { useMsal } from "@azure/msal-react";
import FilterServices from "../../../services/FilterServices";
import InputAdornment from "@mui/material/InputAdornment";
import { connect } from "react-redux";
import Loading from "../../Components/Loading";
import user from "../../../assets/images/user.png";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import user1 from "../../../assets/images/Avatar.png";
import user2 from "../../../assets/images/User2.png";
import UserDetailsServices from "../../../services/console_services/LoginLogot";
const useStyles = makeStyles((_theme) => ({
  filterIcon: {
    // width: "40px",
    height: "40px",
    borderRadius: "50px",
    backgroundColor: "#fff",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    margin: "0px 10px",
  },
  editIcon: {
    width: "25px",
    height: "25px",
    borderRadius: "50px",
    backgroundColor: "#2B5692",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    margin: "0px 10px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    margin: "0px 0px 0px 10px",
  },
  popoverContent: {
    display: "flex",
    alignItems: "center",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
}));

const PopOverFilter = ({
  networkFilterChange,
  DCFilterChange,
  productsFilterChange,
  customersFilterChange,
  dateRangeFilterChange,
  ApplyFilterActions,
  SaveFilterActions,
  _DeleteFilterActions,
  Network,
  DC,
  Products,
  Customers,
  date,
  _applyFilter,
  _savedFilters,
  filtersList,
  _setLoginActions,
  _handleLogout,
  pl3FilterChange,
  cl6FilterChange,
  PL3,
  CL6,
  Division,
  divisionFilterChange,
  savedFilterNameFilterChange,
  SavedFilterNameList,
  filterNameChange,
  filterName,
  loading,
  role,
  fromStateFilterAction,
  toStateFilterAction,
  fromZipFilterAction,
  toZipFilterAction,
  laneFilterAction,
  TemperatureFilterAction,
  FacIDFilterAction,
  LocationAction,
  FacTypeFilterAction,
  Temperature,
  Facility,
  FacilityType,
  location,
  fromState,
  toState,
  fromZip,
  toZip,
  lane,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutMenu, setLogoutMenu] = useState(null);
  const [showSavedFilters, setShowSavedFilters] = useState(false);
  const [openPL3, setOpenPL3] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);
  const [openCustomers, setOpenCustomers] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [savedFilterList, setSaveFilterList] = useState([]);
  const [selectedSavedFilter, setSelectedSavedFilter] = useState(null);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedID, setSelectedID] = useState("");
  const [resetMultiSelect, setResetMultiSelect] = useState(false);
  const [saveFilerInitial, setSaveFilerInitial] = useState("None");
  const allData = useSelector((state) => state);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null); // Track which dropdown is open
  // const navigate = useNavigate();
  const transportFilters = ["/ff", "/ds"];
  const GlobalFilters = ["/slp", "/iof", "/iofpb"];
  const storedUserDetails = localStorage.getItem("userDetails");
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  const loginFilter = userDetails?.loginLogOutDetails[0]?.LastFilterID;

  useEffect(() => {
    if (
      loginFilter?.name &&
      saveFilerInitial === "None" &&
      Object.keys(loginFilter).length !== 0
    ) {
      setSaveFilerInitial(
        loginFilter?.name ? loginFilter?.name : saveFilerInitial,
      );
    }
  }, [userDetails]);

  const { accounts } = useMsal();
  const activeAccount = accounts[0];

  // const calculateFourWeeksAgoDate = (date) => {
  //   const fourWeeksAgo = new Date(date);
  //   fourWeeksAgo.setDate(fourWeeksAgo.getDate() - 28);
  //   return fourWeeksAgo.toISOString().slice(0, 10);
  // };

  // const endDate = new Date().toISOString().slice(0, 10);
  // const startDate = calculateFourWeeksAgoDate(new Date());

  // const initialDates = [startDate, endDate];
  const classes = useStyles();
  const { instance } = useMsal();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setSelectedSavedFilter(null);
    setSelectedID("");
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLogoutMenu(null);
    // networkFilterChange("");
    // savedFilterNameFilterChange("");
    // DCFilterChange("");
    // productsFilterChange("");
    // pl3FilterChange("");
    // divisionFilterChange("");
    // dateRangeFilterChange(initialDates);
    // setLogoutMenu(null);
    // setSelectedSavedFilter(null)
    // setSelectedID("")
  };

  const handleReset = () => {
    networkFilterChange([]);
    savedFilterNameFilterChange([]);
    DCFilterChange([]);
    productsFilterChange([]);
    customersFilterChange([]);
    pl3FilterChange([]);
    cl6FilterChange([]);
    divisionFilterChange([]);
    //dateRangeFilterChange(initialDates);
    filterNameChange([]);
    setSelectedSavedFilter(null);
    setSelectedID([]);
    setSelectedMaterials([]);
    setSelectedCustomers([]);
    setResetMultiSelect(true);
    setSaveFilerInitial("None");
    fromStateFilterAction([]);
    toStateFilterAction([]);
    fromZipFilterAction([]);
    toZipFilterAction([]);
    laneFilterAction([]);
    FacIDFilterAction([]);
    LocationAction([]);
    TemperatureFilterAction([]);
    FacTypeFilterAction([]);
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (!userDetails) {
      return;
    }
    if (!Array.isArray(userDetails.loginLogOutDetails)) {
      userDetails.loginLogOutDetails = [{}];
    }
    userDetails.loginLogOutDetails[0] = {
      ...userDetails.loginLogOutDetails[0],
      LastFilterID: {},
      LastViewPage: "",
    };
    localStorage.setItem("userDetails", JSON.stringify(userDetails));
  };

  const handleSaveFilters = () => {
    const filterValues = [
      {
        Network: Network,
        DC: DC,
        Products: Products,
        Customers: Customers,
        PL3: PL3,
        CL6: CL6,
        Division: Division,
        Date: date,
      },
    ];
    setShowSavedFilters(!showSavedFilters);
    SaveFilterActions(filterValues);
    var existingArrayJSON = localStorage.getItem("filter");
    var existingArray = existingArrayJSON ? JSON.parse(existingArrayJSON) : [];
    existingArray = existingArray.concat(filterValues);
    localStorage.setItem("filter", JSON.stringify(existingArray));
  };

  const handleSavedFilterClose = () => {
    setShowSavedFilters(false);
  };

  const handleSavedFilterNames = (filterNameList) => {
    const nameList = SavedFilterNameList;
    nameList.push({ name: filterNameList });
    setShowSavedFilters(false);
    savedFilterNameFilterChange(nameList);
    setAnchorEl(null);
  };

  const getAllSavedFilters = (params) => {
    FilterServices.getAllSavedFilters(params, instance)
      .then((data) => {
        if (data?.data) {
          setSaveFilterList(data?.data);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    const params = {
      UserID: activeAccount?.username,
      Level: role,
    };
    if (anchorEl) {
      getAllSavedFilters(params);
    }
  }, [anchorEl]);

  const handleApplyFilter = () => {
    const filterValues = [
      {
        Network: selectedSavedFilter ? selectedSavedFilter.Network : Network,
        DC: selectedSavedFilter ? selectedSavedFilter.RecommendedDC : DC,
        Products: selectedSavedFilter ? selectedSavedFilter.Products : Products,
        Customers: selectedSavedFilter
          ? selectedSavedFilter.Customers
          : Customers,
        PL3: selectedSavedFilter ? selectedSavedFilter.PL3 : PL3,
        CL6: selectedSavedFilter ? selectedSavedFilter.CL6 : CL6,
        Date: selectedSavedFilter ? selectedSavedFilter.Date : date,
        Division: selectedSavedFilter ? selectedSavedFilter.Division : Division,
        Temperature: selectedSavedFilter
          ? selectedSavedFilter.Temperature
          : Temperature,
        Facility: selectedSavedFilter ? selectedSavedFilter.Facility : Facility,
        fromState: selectedSavedFilter
          ? selectedSavedFilter.fromState
          : fromState,
        toState: selectedSavedFilter ? selectedSavedFilter.toState : toState,
        fromZip: selectedSavedFilter ? selectedSavedFilter.fromZip : fromZip,
        toZip: selectedSavedFilter ? selectedSavedFilter.toZip : toZip,
        lane: selectedSavedFilter ? selectedSavedFilter.lane : lane,
      },
    ];
    ApplyFilterActions(filterValues);
    setAnchorEl(null);
  };

  const handleClickUser = (event) => {
    setLogoutMenu(event.currentTarget);
  };

  const handleClickLogout = () => {
    const currentTime = new Date().toISOString();
    let lastViewPath;
    if (
      window.location.pathname === "/error" ||
      window.location.pathname === ""
    ) {
      lastViewPath = "/";
    } else {
      lastViewPath = window.location.pathname;
    }

    // Initialize params based on the value of saveFilerInitial
    let params;
    params = {
      LogoutTime: currentTime,
      LastViewPage: lastViewPath,
      LastFilterID: {
        DC,
        Products,
        Customers,
        date,
        PL3,
        CL6,
        Division,
        Network,
        Facility,
        Temperature,
        fromState,
        toState,
        fromZip,
        toZip,
        lane,
      },
    };
    UserDetailsServices.updateLastView(params, instance).then((_data) => {
      instance.logoutRedirect().catch((error) => console.log(error));
      sessionStorage.clear();
      //localStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails");
    });
  };

  const handleClickProducts = () => {
    setOpenProducts(true);
  };

  const handleClickCustomers = () => {
    setOpenCustomers(true);
  };

  const handleApply = (_selectedItems) => {
    setOpenPL3(false);
  };

  const handleProductsApply = (selectedItems) => {
    productsFilterChange(selectedItems);
    setOpenProducts(false);
  };

  const handleCustomersApply = (selectedItems) => {
    customersFilterChange(selectedItems);
    setOpenCustomers(false);
  };

  const handlePL3Close = () => {
    setOpenPL3(false);
  };

  const handleProductsClose = () => {
    setOpenProducts(false);
  };

  const handleCustomersClose = () => {
    setOpenCustomers(false);
  };

  const handleProductCheckboxChange = (id) => {
    setSelectedMaterials((prevState) =>
      prevState.includes(id)
        ? prevState.filter((materialId) => materialId !== id)
        : [...prevState, id],
    );
    productsFilterChange(selectedMaterials);
  };

  const handleCustomerCheckboxChange = (id) => {
    setSelectedCustomers((prevState) =>
      prevState.includes(id)
        ? prevState.filter((materialId) => materialId !== id)
        : [...prevState, id],
    );
    customersFilterChange(selectedMaterials);
  };

  const handleEditFilterClick = () => {
    setOpenEdit(true);
  };

  const handleEditSavedFilterClose = () => {
    setOpenEdit(false);
    // setSelectedSavedFilter(null);
    setSelectedID("");
  };

  const handleSavedFilterEdit = (id, item) => {
    const filteredItem = savedFilterList.find((item) => item.id === id);
    if (!filteredItem) {
      return;
    }
    const { FilterInfo } = filteredItem;
    setSelectedSavedFilter(FilterInfo);
    setSelectedID(filteredItem.id);
    setSaveFilerInitial(item?.FilterName);
    const filterMapping = {
      Network: networkFilterChange,
      RecommendedDC: DCFilterChange,
      Products: productsFilterChange,
      Customers: customersFilterChange,
      PL3: pl3FilterChange,
      CL6: cl6FilterChange,
      Division: divisionFilterChange,
      Date: dateRangeFilterChange,
      fromState: fromStateFilterAction,
      toState: toStateFilterAction,
      fromZip: fromZipFilterAction,
      toZip: toZipFilterAction,
      lane: laneFilterAction,
      Facility: FacIDFilterAction,
      location: LocationAction,
      FacilityType: FacTypeFilterAction,
      Temperature: TemperatureFilterAction,
    };

    Object.entries(filterMapping).forEach(([key, updateFunction]) => {
      if (FilterInfo[key]) {
        updateFunction(FilterInfo[key]);
      }
    });

    setOpenEdit(false);
  };

  const deleteSavedFilters = (id) => {
    FilterServices.deleteSavedFilters(id, instance)
      .then((_data) =>
        getAllSavedFilters({
          UserID: activeAccount?.username,
          Level: role,
        }),
      )
      .catch((error) => console.error("Error:", error));
  };
  const handleFiltersDelete = (id) => {
    deleteSavedFilters(id);
  };

  const handleSavedFilter = (value) => {
    setSaveFilerInitial(value);
    if (value?.length > 0) {
      const filteredList = savedFilterList?.filter(
        (item) => value === item?.FilterName,
      );
      let filterInfo = filteredList[0]?.FilterInfo;
      setSelectedSavedFilter(filterInfo);
      // if (filteredList?.length > 0) {
      //   if (filteredList.length === 1) {
      //     filterInfo = filteredList[0].FilterInfo;
      //   } else {
      //     filterInfo = filteredList[1].FilterInfo;
      //   }
      //   setSelectedSavedFilter(filterInfo);
      // }
    } else {
      setSelectedSavedFilter(null);
    }
  };

  useEffect(() => {
    const filterMapping = {
      Network: networkFilterChange,
      RecommendedDC: DCFilterChange,
      Products: productsFilterChange,
      Customers: customersFilterChange,
      PL3: pl3FilterChange,
      CL6: cl6FilterChange,
      Division: divisionFilterChange,
      Date: dateRangeFilterChange,
      fromState: fromStateFilterAction,
      toState: toStateFilterAction,
      fromZip: fromZipFilterAction,
      toZip: toZipFilterAction,
      lane: laneFilterAction,
      Facility: FacIDFilterAction,
      location: LocationAction,
      FacilityType: FacTypeFilterAction,
      Temperature: TemperatureFilterAction,
    };
    if (selectedSavedFilter) {
      Object.entries(filterMapping).forEach(([key, updateFunction]) => {
        if (selectedSavedFilter[key]) {
          updateFunction(selectedSavedFilter[key]);
        }
      });
    } else {
      // -------------------------------------------------------------------------------------------------------------------------
    }
  }, [selectedSavedFilter]);

  const handleClickApply = () => {
    handleApplyFilter();
  };

  const getFilteredListByProperty = (list, property) => {
    // If the list is not an array or is falsy, return an empty array
    if (!Array.isArray(list)) {
      return [];
    }

    // Check if any item in the list has the specified property
    return list.some((item) => item && item.hasOwnProperty(property))
      ? list.map((item) => item[property]).filter(Boolean) // Include only non-null, non-undefined values
      : [];
  };

  // Example usage to get the division list
  const networkList = getFilteredListByProperty(
    allData?.filter?.filteredList?.Network,
    "Network",
  );
  const divisionList = getFilteredListByProperty(
    allData?.filter?.filteredList?.division,
    "Division",
  );
  const pl3List = getFilteredListByProperty(
    allData?.filter?.filteredList?.PL3,
    "ProductLevel3CategoryDescription",
  );

  const cl6List = getFilteredListByProperty(
    allData?.filter?.filteredList?.CL6,
    "CL6",
  );
  // console.log(allData, 'allData', cl6List, selectedSavedFilter);
  const dcList = getFilteredListByProperty(
    allData?.filter?.filteredList?.DC,
    "DC",
  );

  const productList = getFilteredListByProperty(
    allData?.filter?.filteredProducts,
    "MaterialID",
  );

  const customerList = getFilteredListByProperty(
    allData?.filter?.filteredCustomers,
    "SoldToName",
  );
  const Destination_3zip = getFilteredListByProperty(
    allData?.filter?.filteredList?.Destination_3zip,
    "Destination_3zip",
  );
  const Destination_State = getFilteredListByProperty(
    allData?.filter?.filteredList?.Destination_State,
    "Destination_State",
  );
  const Lane = getFilteredListByProperty(
    allData?.filter?.filteredList?.Lane,
    "Lane",
  );
  const Source_3zip = getFilteredListByProperty(
    allData?.filter?.filteredList?.Source_3zip,
    "Source_3zip",
  );
  const Source_State = getFilteredListByProperty(
    allData?.filter?.filteredList?.Source_State,
    "Source_State",
  );
  const TemperatureValue = getFilteredListByProperty(
    allData?.filter?.filteredList?.Temperature,
    "Temperature",
  );
  const FacilityValue = getFilteredListByProperty(
    allData?.filter?.filteredList?.Facility,
    "Facility",
  );
  const FacilityTypeValue = getFilteredListByProperty(
    allData?.filter?.filteredList?.FacilityType,
    "FacilityType",
  );

  const SpendLocationValue = getFilteredListByProperty(
    allData?.filter?.filteredList?.Spend_Location_Type,
    "Spend_Location_Type",
  );
  const allowedValues = ["AMBIENT", "CHILLED", "FROZEN", "NPW", "IPW"];
  const filteredNetworkList = networkList.filter((network) =>
    allowedValues.includes(network),
  );

  const handleDropdownToggle = (dropdownIndex) => {
    if (openDropdownIndex === dropdownIndex) {
      setOpenDropdownIndex(null); // Close the dropdown if it's already open
    } else {
      setOpenDropdownIndex(dropdownIndex); // Open the clicked dropdown
    }
  };

  const handleChipRemove = (title, upatedVal) => {
    if (title === "Network") {
      networkFilterChange(upatedVal);
    } else if (title === "DC") {
      DCFilterChange(upatedVal);
    } else if (title === "CL6") {
      cl6FilterChange(upatedVal);
    } else if (
      title === "PL3" ||
      title === "ProductLevel3CategoryDescription"
    ) {
      pl3FilterChange(upatedVal);
    } else if (title === "Facility") {
      FacIDFilterAction(upatedVal);
    } else if (title === "FacilityType") {
      FacTypeFilterAction(upatedVal);
    } else if (title === "Location") {
      LocationAction(upatedVal);
    } else if (title === "lane") {
      laneFilterAction(upatedVal);
    } else if (title === "Temperature") {
      TemperatureFilterAction(upatedVal);
    } else if (title === "toZip") {
      toZipFilterAction(upatedVal);
    } else if (title === "fromZip") {
      fromZipFilterAction(upatedVal);
    } else if (title === "toState") {
      toStateFilterAction(upatedVal);
    } else if (title === "fromState") {
      fromStateFilterAction(upatedVal);
    }
  };

  const level = JSON.parse(localStorage.getItem("Level"));

  const UserLevel = level === "L0" ? user1 : user2;

  return (
    <div>
      <div className={classes.iconContainer}>
        <div
          style={{
            background: "rgba(0, 0, 0, 0.10)",
            width: "1px",
            height: "45px",
          }}
        />
        <div className={classes.filterIcon}>
          <FilterIcon
            onClick={handleClick}
            style={{ color: "rgba(43, 86, 146, 1)" }}
          />
        </div>
        <div
          style={{
            background: "rgba(0, 0, 0, 0.10)",
            width: "1px",
            height: "45px",
          }}
        />
        <div className={classes.filterIcon}>
          <Avatar
            alt="Nestle"
            src={UserLevel}
            width="32.368px"
            height="32.368px"
            style={{ color: "rgba(43, 86, 146, 1)" }}
            onClick={handleClickUser}
          />
        </div>
        <Menu
          id="logout-menu"
          anchorEl={logoutMenu}
          open={Boolean(logoutMenu)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={handleClickLogout}
            style={{
              backgroundColor: "#F5F7F4",
              borderRadius: "10px",
              padding: "10px",
              fontSize: "14px",
            }}
          >
            Logout
          </MenuItem>
        </Menu>
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            backgroundColor: "#F5F7F4",
            borderRadius: "10px",
            width: "fit-content",
            padding: "10px",
            marginTop: {
              xs: "40px",
              sm: "40px",
              md: "40px",
              lg: "40px",
              xl: "10px",
            },
            "@media (min-width: 1440px)": {
              marginTop: "40px",
            },
          },
        }}
      >
        {loading ? (
          <div className={classes.loaderContainer}>
            <Loading />
          </div>
        ) : (
          <>
            <div className={classes.popoverContent}>
              <Typography
                sx={{
                  p: 2,
                  fontSize: "16px",
                  color: "#222",
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                Filters
              </Typography>
              <div style={{ marginLeft: "auto", marginRight: "15px" }}>
                {showSavedFilters || openEdit ? (
                  ""
                ) : (
                  <SaveIcon
                    className={classes.icons}
                    onClick={handleSaveFilters}
                  />
                )}
              </div>
            </div>
            {showSavedFilters ? (
              <SavedFilters
                handleSavedFilterNames={handleSavedFilterNames}
                handleClose={handleSavedFilterClose}
                selectedSavedFilter={selectedSavedFilter}
                selectedID={selectedID}
                role={role}
                handleReset={handleReset}
              />
            ) : (
              <>
                {openEdit ? (
                  <EditSavedFilters
                    filterName={filterName}
                    handleEditSavedFilterClose={handleEditSavedFilterClose}
                    savedFilterList={savedFilterList}
                    handleSavedFilterEdit={handleSavedFilterEdit}
                    handleFiltersDelete={handleFiltersDelete}
                    selectedSavedFilter={selectedSavedFilter}
                  />
                ) : (
                  <>
                    <List>
                      <ListItem>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#222",
                            fontFamily: "Poppins",
                          }}
                        >
                          Saved Filter/SKU Owner
                        </Typography>
                      </ListItem>

                      <ListItem sx={{ paddingTop: "0px", paddingRight: "0px" }}>
                        <SelectFilter
                          toggleDropdown={() => handleDropdownToggle(1)}
                          isOpen={openDropdownIndex === 1}
                          resetMultiSelect={resetMultiSelect}
                          setResetMultiSelect={setResetMultiSelect}
                          title={"name"}
                          width={"100px"}
                          placeHolder={"None"}
                          singleSelect
                          handleChange={(value) => handleSavedFilter(value)}
                          value={saveFilerInitial}
                          list={savedFilterList.map((item) => item.FilterName)}
                        />
                        <div
                          className={classes.editIcon}
                          onClick={
                            savedFilterList.length > 0
                              ? handleEditFilterClick
                              : undefined
                          }
                        >
                          <EditOutlinedIcon
                            style={{
                              color: "#fff",
                              fontSize: "12px",
                              cursor:
                                savedFilterList.length > 0
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          />
                        </div>
                      </ListItem>
                      <ListItem>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#222",
                            fontFamily: "Poppins",
                          }}
                        >
                          Network
                        </Typography>
                      </ListItem>
                      <ListItem sx={{ paddingTop: "0px" }}>
                        <SelectFilter
                          toggleDropdown={() => handleDropdownToggle(2)}
                          isOpen={openDropdownIndex === 2}
                          resetMultiSelect={resetMultiSelect}
                          setResetMultiSelect={setResetMultiSelect}
                          title={"Network"}
                          placeHolder={"All"}
                          handleChange={(value) => networkFilterChange(value)}
                          value={
                            selectedSavedFilter
                              ? selectedSavedFilter.Network
                              : Network
                          }
                          list={filteredNetworkList}
                          onChipRemove={handleChipRemove}
                        />
                      </ListItem>
                      {transportFilters.includes(window.location.pathname) ? (
                        <>
                          {window.location.pathname === "/ff" && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                              }}
                            >
                              <ListItem
                                sx={{
                                  paddingTop: "0px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  From State
                                </Typography>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(6)}
                                  isOpen={openDropdownIndex === 6}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"fromState"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    fromStateFilterAction(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.fromState
                                      : fromState
                                  }
                                  list={Source_State}
                                />
                              </ListItem>

                              <ListItem
                                sx={{
                                  paddingTop: "0px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  To State
                                </Typography>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(7)}
                                  isOpen={openDropdownIndex === 7}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"toState"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    toStateFilterAction(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.toState
                                      : toState
                                  }
                                  list={Destination_State}
                                />
                              </ListItem>
                            </div>
                          )}
                          {window.location.pathname === "/ff" && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                              }}
                            >
                              <ListItem
                                sx={{
                                  paddingTop: "0px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  From 3Zip
                                </Typography>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(8)}
                                  isOpen={openDropdownIndex === 8}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"fromZip"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    fromZipFilterAction(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.fromZip
                                      : fromZip
                                  }
                                  list={Source_3zip}
                                />
                              </ListItem>

                              <ListItem
                                sx={{
                                  paddingTop: "0px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  To 3Zip
                                </Typography>
                                <SelectFilter
                                  toggleDropdown={() =>
                                    handleDropdownToggle(10)
                                  }
                                  isOpen={openDropdownIndex === 10}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"toZip"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    toZipFilterAction(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.toZip
                                      : toZip
                                  }
                                  list={Destination_3zip}
                                />
                              </ListItem>
                            </div>
                          )}

                          <ListItem>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#222",
                                fontFamily: "Poppins",
                              }}
                            >
                              Lane
                            </Typography>
                          </ListItem>
                          <ListItem sx={{ paddingTop: "0px" }}>
                            <SelectFilter
                              toggleDropdown={() => handleDropdownToggle(11)}
                              isOpen={openDropdownIndex === 11}
                              resetMultiSelect={resetMultiSelect}
                              setResetMultiSelect={setResetMultiSelect}
                              title={"lane"}
                              placeHolder={"All"}
                              handleChange={(value) => laneFilterAction(value)}
                              value={
                                selectedSavedFilter
                                  ? selectedSavedFilter.lane
                                  : lane
                              }
                              list={Lane}
                              onChipRemove={handleChipRemove}
                            />
                          </ListItem>

                          <ListItem>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#222",
                                fontFamily: "Poppins",
                              }}
                            >
                              Temperature
                            </Typography>
                          </ListItem>
                          <ListItem sx={{ paddingTop: "0px" }}>
                            <SelectFilter
                              toggleDropdown={() => handleDropdownToggle(12)}
                              isOpen={openDropdownIndex === 12}
                              resetMultiSelect={resetMultiSelect}
                              setResetMultiSelect={setResetMultiSelect}
                              title={"Temperature"}
                              placeHolder={"All"}
                              handleChange={(value) =>
                                TemperatureFilterAction(value)
                              }
                              value={
                                selectedSavedFilter
                                  ? selectedSavedFilter.Temperature
                                  : Temperature
                              }
                              list={TemperatureValue}
                              listPosition="top"
                              onChipRemove={handleChipRemove}
                            />
                          </ListItem>
                          {window.location.pathname !== "/ff" && (
                            <>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Spend Location Type
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() =>
                                    handleDropdownToggle(25)
                                  }
                                  isOpen={openDropdownIndex === 25}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"Location"}
                                  placeHolder={"All"}
                                  handleChange={(value) => {
                                    LocationAction(value);
                                  }}
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter?.location
                                      : location
                                  }
                                  list={SpendLocationValue}
                                  listPosition="top"
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Facility Type
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() =>
                                    handleDropdownToggle(13)
                                  }
                                  isOpen={openDropdownIndex === 13}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"Facility"}
                                  placeHolder={"All"}
                                  handleChange={(value) => {
                                    FacIDFilterAction(value);
                                  }}
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter?.Facility
                                      : Facility
                                  }
                                  list={FacilityValue}
                                  listPosition="top"
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Facility
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() =>
                                    handleDropdownToggle(14)
                                  }
                                  isOpen={openDropdownIndex === 14}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"FacilityType"}
                                  placeHolder={"All"}
                                  handleChange={(value) => {
                                    FacTypeFilterAction(value);
                                  }}
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter?.FacilityType
                                      : FacilityType
                                  }
                                  list={FacilityTypeValue}
                                  listPosition="top"
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {GlobalFilters.includes(window.location.pathname) ? (
                            <>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  DC
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() =>
                                    handleDropdownToggle(35)
                                  }
                                  isOpen={openDropdownIndex === 35}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"DC"}
                                  handleChange={(value) =>
                                    DCFilterChange(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.RecommendedDC
                                      : DC
                                  }
                                  list={dcList}
                                  placeHolder={"All"}
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  CL6
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(4)}
                                  isOpen={openDropdownIndex === 4}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"CL6"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    cl6FilterChange(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.CL6
                                      : CL6
                                  }
                                  list={cl6List}
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  PL3
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(5)}
                                  isOpen={openDropdownIndex === 5}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"PL3"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    pl3FilterChange(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.PL3
                                      : PL3
                                  }
                                  list={pl3List}
                                  listPosition="top"
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  SKU
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <TextField
                                  hiddenLabel
                                  id="payload-decrease"
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    width: "100%",
                                    borderColor: "transparent",
                                    borderStyle: "none",
                                    borderRadius: "4px",
                                    background: "#FFF",
                                    "& .MuiInputBase-input": {
                                      height: "15px",
                                    },
                                    "&:focus": {
                                      backgroundColor: "#FFF",
                                    },
                                    "&:hover": {
                                      backgroundColor: "#FFF",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Typography
                                          style={{
                                            marginRight: "10px",
                                            color: "#4C4C4D",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          {selectedMaterials.length ===
                                          filtersList.products
                                            ? "All"
                                            : `${Products.length} selected`}
                                        </Typography>
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Typography
                                          style={{
                                            marginRight: "10px",
                                            color: "#007CBA",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleClickProducts}
                                        >
                                          View All Products
                                        </Typography>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Sold to Customer
                                </Typography>
                              </ListItem>

                              <ListItem sx={{ paddingTop: "0px" }}>
                                <TextField
                                  hiddenLabel
                                  id="payload-decrease"
                                  variant="outlined"
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Typography
                                          style={{
                                            marginRight: "10px",
                                            color: "#4C4C4D",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          {selectedCustomers.length ===
                                          filtersList.customers
                                            ? "All"
                                            : `${Customers.length} selected`}
                                        </Typography>
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Typography
                                          style={{
                                            marginRight: "10px",
                                            color: "#007CBA",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleClickCustomers}
                                        >
                                          View All Customers
                                        </Typography>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </ListItem>
                            </>
                          ) : (
                            <>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Division
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(3)}
                                  isOpen={openDropdownIndex === 3}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"Division"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    divisionFilterChange(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.Division
                                      : Division
                                  }
                                  list={divisionList}
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  PL3
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(4)}
                                  isOpen={openDropdownIndex === 4}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"ProductLevel3CategoryDescription"}
                                  placeHolder={"All"}
                                  handleChange={(value) =>
                                    pl3FilterChange(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.PL3
                                      : PL3
                                  }
                                  list={pl3List}
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  DCs
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <SelectFilter
                                  toggleDropdown={() => handleDropdownToggle(5)}
                                  isOpen={openDropdownIndex === 5}
                                  resetMultiSelect={resetMultiSelect}
                                  setResetMultiSelect={setResetMultiSelect}
                                  title={"DC"}
                                  handleChange={(value) =>
                                    DCFilterChange(value)
                                  }
                                  value={
                                    selectedSavedFilter
                                      ? selectedSavedFilter.RecommendedDC
                                      : DC
                                  }
                                  list={dcList}
                                  placeHolder={"All"}
                                  listPosition="top"
                                  onChipRemove={handleChipRemove}
                                />
                              </ListItem>
                              <ListItem>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#222",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Products
                                </Typography>
                              </ListItem>
                              <ListItem sx={{ paddingTop: "0px" }}>
                                <TextField
                                  hiddenLabel
                                  id="payload-decrease"
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    width: "100%",
                                    borderColor: "transparent",
                                    borderStyle: "none",
                                    borderRadius: "4px",
                                    background: "#FFF",
                                    "& .MuiInputBase-input": {
                                      height: "15px",
                                    },
                                    "&:focus": {
                                      backgroundColor: "#FFF",
                                    },
                                    "&:hover": {
                                      backgroundColor: "#FFF",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Typography
                                          style={{
                                            marginRight: "10px",
                                            color: "#4C4C4D",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          {selectedMaterials.length ===
                                          filtersList.products
                                            ? "All"
                                            : `${Products.length} selected`}
                                        </Typography>
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Typography
                                          style={{
                                            marginRight: "10px",
                                            color: "#007CBA",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleClickProducts}
                                        >
                                          View All Products
                                        </Typography>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </ListItem>
                            </>
                          )}
                        </>
                      )}
                    </List>
                    <div
                      style={{
                        display: "flex",
                        padding: "13px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        style={{
                          borderRadius: "4px",
                          background: "#2B5692",
                          fontSize: "12px",
                          textTransform: "none",
                        }}
                        onClick={handleClickApply}
                      >
                        Apply Filters
                      </Button>
                      <Button
                        disabled={
                          !Network &&
                          !DC &&
                          !PL3 &&
                          !Division &&
                          Products.length === 0
                        }
                      >
                        <CachedOutlinedIcon
                          className={classes.icons}
                          onClick={handleReset}
                        />
                      </Button>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Popover>
      <PL3Filters
        open={openPL3}
        handleApply={handleApply}
        handlePL3Close={handlePL3Close}
      />
      <ProductsFilters
        open={openProducts}
        productsList={productList}
        handleProductsApply={handleProductsApply}
        handleProductsClose={handleProductsClose}
        selectedMaterials={selectedMaterials}
        handleProductCheckboxChange={handleProductCheckboxChange}
        Products={Products}
        setSelectedMaterials={setSelectedMaterials}
      />
      <ProductsFilters
        open={openCustomers}
        productsList={customerList}
        handleProductsApply={handleCustomersApply}
        handleProductsClose={handleCustomersClose}
        selectedMaterials={selectedCustomers}
        handleProductCheckboxChange={handleCustomerCheckboxChange}
        Products={Customers}
        setSelectedMaterials={setSelectedCustomers}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  Customers: state.filter.Customers,
  PL3: state.filter.PL3,
  CL6: state.filter.CL6,
  date: state.filter.Date,
  Division: state.filter.Division,
  SavedFilterNameList: state.filter.SavedFilterNameList,
  filterName: state.filter.filterName,
  applyFilter: state.filter.applyFilter,
  savedFilters: state.filter.filters,
  filtersList: state.filter.filtersList,
  role: state.login.role,
  Temperature: state.filter.Temperature,
  Facility: state.filter.facId,
  location: state.filter.location,
  FacilityType: state.filter.facType,
  fromState: state.filter.fromState,
  toState: state.filter.toState,
  fromZip: state.filter.fromZip,
  toZip: state.filter.toZip,
  lane: state.filter.lane,
});

const mapDispatchToProps = (dispatch) => ({
  networkFilterChange: (newValue) =>
    dispatch({ type: "FILTER_NETWORK", payload: newValue }),
  DCFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DC", payload: newValue }),
  productsFilterChange: (newValue) =>
    dispatch({ type: "FILTER_PRODUCTS", payload: newValue }),
  customersFilterChange: (newValue) =>
    dispatch({ type: "FILTER_CUSTOMERS", payload: newValue }),
  pl3FilterChange: (newValue) =>
    dispatch({ type: "FILTER_PL3", payload: newValue }),
  cl6FilterChange: (newValue) =>
    dispatch({ type: "FILTER_CL6", payload: newValue }),
  divisionFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DIVISION", payload: newValue }),
  savedFilterNameFilterChange: (newValue) =>
    dispatch({ type: "FILTER_SAVEDNAMES", payload: newValue }),
  filterNameChange: (newValue) =>
    dispatch({ type: "FILTER_NAMES", payload: newValue }),
  dateRangeFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DATERANGE", payload: newValue }),
  ApplyFilterActions: (newValue) =>
    dispatch({ type: "APPLY_FILTER", payload: newValue }),
  SaveFilterActions: (filters) =>
    dispatch({ type: "SAVE_FILTER", payload: filters }),
  DeleteFilterActions: (index) =>
    dispatch({ type: "DELETE_FILTER", payload: index }),
  setLoginActions: (value) => dispatch({ type: "SET_LOGIN", payload: value }),

  fromStateFilterAction: (value) =>
    dispatch({ type: "FROM_STATE", payload: value }),
  toStateFilterAction: (value) =>
    dispatch({ type: "TO_STATE", payload: value }),
  fromZipFilterAction: (value) =>
    dispatch({ type: "FROM_ZIP", payload: value }),
  toZipFilterAction: (value) => dispatch({ type: "TO_ZIP", payload: value }),
  laneFilterAction: (value) => dispatch({ type: "LANE", payload: value }),
  TemperatureFilterAction: (value) =>
    dispatch({ type: "TEMPERATURE", payload: value }),
  FacIDFilterAction: (value) => dispatch({ type: "FAC_ID", payload: value }),
  LocationAction: (value) => dispatch({ type: "LOCATION", payload: value }),

  FacTypeFilterAction: (value) =>
    dispatch({ type: "FAC_TYPE", payload: value }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PopOverFilter);
